import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

// Wrapper Imports (Auth)
import LazyLoadWrapper from "./lazy-load-wrapper";
import ProtectedRoute from "./protected-route";

// Layout Imports
import DefaultLayout from "../layouts/default-layout";

// Lazy loaded pages
const Home = lazy(() => import("../pages/home/home-page"));
const CoverageMap = lazy(
    () => import("../pages/coverage-map/coverage-map-page")
);
const Checkout = lazy(() => import("../pages/checkout/checkout-page"));
const Dashboard = lazy(() => import("../pages/dashboard/dashboard-page"));
const Profile = lazy(() => import("../pages/profile/profile-page"));
const Payment = lazy(() => import("../pages/payment/payment-page"));
const GetHelp = lazy(() => import("../pages/get-help/get-help-page"));
const GetHelpQuestionView = lazy(
    () => import("../pages/get-help-question-view/get-help-question-view")
);
const KnowledgeCenter = lazy(
    () => import("../pages/knowledge-center/knowledge-center-page")
);
const KnowledgeCenterLinkView = lazy(
    () => import("../pages/knowledge-center-link-view/knowledge-center-link-view")
);
const ContactSupport = lazy(
    () => import("../pages/contact-support/contact-support-page")
);
const SignInPage = lazy(() => import("../components/sign-in/sign-in-page"));
const Support = lazy(() => import("../pages/support/support-page"));
const TermsPage = lazy(() => import("../pages/terms-and-conditions/TermsPage"));
const OfferingsPage = lazy( () => import("../pages/offerings/offerings"));

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<DefaultLayout />}>
                <Route index element={<LazyLoadWrapper component={Home} />} />
                <Route
                    path="coverage-map"
                    element={<LazyLoadWrapper component={CoverageMap} />}
                />
                <Route
                    path="checkout"
                    element={<LazyLoadWrapper component={Checkout} />}
                />
                <Route
                    path="payment"
                    element={<LazyLoadWrapper component={Payment} />}
                />
                <Route
                    path="get-help"
                    element={<LazyLoadWrapper component={GetHelp} />}
                />
                <Route
                    path="get-help/faq/:id"
                    element={<LazyLoadWrapper component={GetHelpQuestionView} />}
                />
                <Route
                    path="knowledge-center"
                    element={<LazyLoadWrapper component={KnowledgeCenter} />}
                />
                <Route
                    path="knowledge-center/link/:id"
                    element={<LazyLoadWrapper component={KnowledgeCenterLinkView} />}
                />
                <Route
                    path="support"
                    element={<LazyLoadWrapper component={ContactSupport} />}
                />
                <Route
                    path="sign-in"
                    element={<LazyLoadWrapper component={SignInPage} />}
                />
                <Route
                    path="terms-and-conditions"
                    element={<LazyLoadWrapper component={TermsPage} />}
                />
            </Route>

            {/* Private Routes */}
            <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<DefaultLayout />}>
                    <Route index element={<LazyLoadWrapper component={Dashboard} />} />
                    <Route
                        path="profile"
                        element={<LazyLoadWrapper component={Profile} />}
                    >
                    </Route>
                    <Route
                        path="tickets"
                        element={<LazyLoadWrapper component={Support} />}
                    />
                </Route>
                <Route path="/offerings" element={<DefaultLayout />}>
                    <Route index element={<LazyLoadWrapper component={OfferingsPage} />} />
                </Route>
            </Route>
        </Routes>
    );
};

export default AppRoutes;
